const TERMS_OF_USE_URL = "https://www.cmegroup.com/files/terms-of-use.pdf";
const DISCLAIMER_URL = "https://www.cmegroup.com/disclaimer.html";
const PRIVACY_POLICY_URL = "https://www.cmegroup.com/privacy-policy.html";

const ECONOMIC_RESEARCH_INSIGHTS_URL =
  "https://www.cmegroup.com/insights/economic-research.html";
const MARKET_COMMENTARY_VIDEOS_URL =
  "https://www.cmegroup.com/videos.html#filters=market-commentary";
const PRODUCT_ANALYSIS_COMMENTARY_URL =
  "https://www.cmegroup.com/insights/product-analysis-and-commentary.html";
const CHARTS_PODCAST_SERIES_URL =
  "https://www.cmegroup.com/podcasts/off-the-charts-podcast-series.html";

export const CME_GROUP_POSTER_URL =
  "https://freshershunt.in/wp-content/uploads/2023/12/CME-Group.jpeg";

export const EXTERNAL_LINKS = [
  {
    title: "Terms of Use",
    link: TERMS_OF_USE_URL,
  },
  {
    title: "Disclaimer Policy",
    link: DISCLAIMER_URL,
  },
  {
    title: "Privacy Policy",
    link: PRIVACY_POLICY_URL,
  },
];

export const TOOLS_LINKS = [
  {
    title: "Economic Research",
    link: ECONOMIC_RESEARCH_INSIGHTS_URL,
  },
  {
    title: "Market Commentary Videos",
    link: MARKET_COMMENTARY_VIDEOS_URL,
  },
  {
    title: "Product Analysis and Commentary",
    link: PRODUCT_ANALYSIS_COMMENTARY_URL,
  },
  {
    title: "Off The Charts Podcast Series",
    link: CHARTS_PODCAST_SERIES_URL,
  },
];
